import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
/**
 * Utilities service for manipulating dates/times using moment js
 */
export class DateUtilityService {
    constructor() {
    }

    /**
     * Returns 30days out from today with moment JS
     */
    public Get30DaysOut(): Date {
        return moment().add(30, 'days').toDate();
    }

    public Get30DaysBack():Date{ 
        return moment().add(-30, 'days').toDate(); 
    }

    /**
     * Returns current date from moment JS
     */
    public GetToday(): Date {
        return moment().toDate();
    }

    public GetYesterday(): Date{
        return moment().subtract(1,'day').toDate();
    }
    /**
     * Returns end of month date from moment JS
     */
    public GetEndOfMonth(): Date {
        return moment().endOf('month').toDate();
    }

    /**
     * Returns start of month date from moment JS
     */
    public GetStartOfMonth(): Date {
        return moment().startOf('month').toDate();
    }

    /**
     * Converts a js date object into a datepicker model {year:val, month:val, day:val}
     * @param dateToConvert A JS date object that will be converted
     */
    public ConvertDateToDatePickerModel(dateToConvert:Date):any{
      return { year: dateToConvert.getFullYear(), month: dateToConvert.getMonth() + 1, day: dateToConvert.getDate() };
    }
    /**
     * Returns a new date year, month-1, day from the date struct
     */
    public ConvertDateStructToDate(dateToConvert:NgbDateStruct){
        return new Date(dateToConvert.year, dateToConvert.month-1, dateToConvert.day);
    }

}